import React, { Component } from "react";
import { Link } from "react-router-dom";

import { changeLanguage } from "../actions";
import polIcon from "../images/icons/pol.svg";
import engIcon from "../images/icons/eng.svg";
import rusIcon from "../images/icons/rus.svg";
import { connect } from "react-redux";

class Language extends Component {
  clickHandler = langNew => {
    const langOld = this.props.language;
    if (langNew !== langOld) {
      this.props.changeLanguage(langNew);
    }
  };

  render() {
    const activeLang = this.props.language || "poland";
    return (
      <div style={{ display: "flex" }}>
        <Link
          className={activeLang === "poland" ? "icon active" : "icon"}
          to="/"
          title="Polski"
          onClick={() => this.clickHandler("poland")}
        >
          <img src={polIcon} alt="" />
        </Link>
        <Link
          className={activeLang === "english" ? "icon active" : "icon"}
          to="/"
          title="English"
          onClick={() => this.clickHandler("english")}
        >
          <img src={engIcon} alt="" />
        </Link>
        <Link
          className={activeLang === "russian" ? "icon active" : "icon"}
          to="/"
          title="Русский"
          onClick={() => this.clickHandler("russian")}
        >
          <img src={rusIcon} alt="" />
        </Link>
      </div>
    );
  }
}

const MapStateToProps = state => ({
  language: state.language
});

const mapDispatchToProps = {
  changeLanguage
};

export default connect(
  MapStateToProps,
  mapDispatchToProps
)(Language);
